module.exports = __webpack_public_path__ + "static/media/1.3 Erper Detail Bart vor nach klein.5e49952e.jpg";